export enum ScanningMode {
  REALTIME,
  DEVICE_IMPORT,
  FILE_IMPORT,
  MANUAL_INPUT,
}

export const MIN_HUB_VERSION = 762;
export const MIN_IOS_HUB_VERSION = 1;

// 20 minutes.
export const DEVICE_TIME_DIFFERENCE_ERROR_THRESHOLD_ENGLISH = "20 minutes";
export const DEVICE_TIME_DIFFERENCE_ERROR_THRESHOLD = 1000 * 60 * 20;

export enum ScanStatus {
  PASS,
  WARNING,
  ERROR,
}

export const ScanStatusColor: Record<ScanStatus, string> = {
  [ScanStatus.PASS]: "success",
  [ScanStatus.WARNING]: "error",
  [ScanStatus.ERROR]: "errorRed",
};

export const UNALLOCATED = "UNALLOCATED";

export const EIDPattern = {
  FIFTEEN_DIGIT_PATTERN: /(\d{3}\d{12})/,
  SIXTEEN_DIGIT_PATTERN: /(\d{3} \d{12})/,
  HEX_EID_FORMAT: /[A-Za-z\d]{4}([A-Za-z\d]{12})/,
  ISO_26_DIGIT_PATTERN: /[AR] \d{5} \d (\d{3} \d{12})/,
  ISO_27_DIGIT_PATTERN: /[AR] \d{5} \d \d(\d{3} \d{12})/,
  // eslint-disable-next-line no-control-regex -- STX (0x02) is the device's actual frame-start byte
  ISO_24631_PATTERN: /\x02\d{7}(\d{3})(\d{12})/,
  ISO_24631_W_TIMESTAMP_PATTERN:
    // eslint-disable-next-line no-control-regex -- STX (0x02) is the device's actual frame-start byte
    /\x02\d{7}(\d{3})(\d{12})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/,
};

// When a user is typing, see if their input
export const PossibleSixteenDigitEidInput = /(\d{3} \d{0,12})|(\d{3, 15})/;

export enum ScanListType {
  SaleLot = "SaleLot",
  ScanLot = "ScanLot",
}

export enum DisconnectCause {
  NONE,
  HUB,
  SCANNER,
}

export enum ConnectionStatus {
  DISCONNECTED = "disconnected",
  CONNECTING = "connecting",
  CONNECTED = "connected",
}
